import type { Violation } from '@finn-no/mobility-item-insertion-shared';
import { useCallback } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { focusElement } from '../../../utils/focus.js';
import { getSortedErrorFields } from '../utils/formErrorUtils.js';

interface FocusFirstError {
  methods: UseFormReturn<any>;
  currentStepFields: Set<string>;
  currentStepModel: any[];
}

/**
 * Hook for focusing on the first validation error in a form step.
 * Combines both client-side and server-side errors and focuses on the first error
 * according to the field order in the widget model.
 */
export const useFocusFirstError = ({ methods, currentStepFields, currentStepModel }: FocusFirstError) => {
  const focusFirstError = useCallback(
    (remoteViolations: Violation[] = []) => {
      const sortedErrorFields = getSortedErrorFields(
        methods.formState.errors,
        currentStepModel,
        currentStepFields,
        remoteViolations,
      );

      // Focus on the first error field if any exist
      if (sortedErrorFields.length > 0) {
        focusElement(sortedErrorFields[0]);
      }
    },
    [methods, currentStepFields, currentStepModel],
  );

  return { focusFirstError };
};
